import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    IconButton,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { Orderenq } from "../../Svg";
import { toast } from "react-toastify";
import api from "../../utils/api";

const SuppliersQuote = ({ data, setShowSupplier, enquiryType, handleView, loadings, selectedIndex, showEnquiryAction = true, showOrderAction = true }) => {
    const [loading, setLoading] = useState(false)
    // console.log(data);

    const requiredDate = enquiryType === "EXCESS" ? {
        targetPrice: data?.targetPrice,
        requiredDate: data?.requiredDate,
    } : {}

    const handleSendEnquiry = async (dataas) => {
        const enquiryData = {
            enquiryType: enquiryType,
            enquiryId: data?.enquiryId,
            vendorId: dataas?._id,
            partList: {
                productNumber: dataas?.productNumber,
                quantity: data?.quantity,
                manufacturer: data?.manufacturer,
                ...requiredDate
            },
            total: 100
        }

        try {
            setLoading(true)
            const response = await api.sendEnquiry(enquiryData)
            console.log(response);
            if (response.data) {

                toast.success('Enquiry Sent Successfully')
                handleView(selectedIndex)
            }
        } catch (err) {
            console.log(err);
            toast.error(err.response.data?.message || 'something went wrong')
        }
        finally {
            setLoading(false)
        }
        // console.log(enquiryData);

    }

    const handleCreateOrder = async (dataas) => {
        try {
            // console.log(dataas);

            const enquiryData = {
                orderType: enquiryType,
                enquiryId: data?.enquiryId,
                vendorId: dataas?._id,
                _id: dataas?.enquiryId,
                partList: {
                    productNumber: dataas?.productNumber,
                    quantity: dataas?.quantity,
                    manufacturer: data?.manufacturer,
                    quotePrice: dataas?.quotePrice,
                    moq: dataas?.moq
                },
                total: dataas?.quotePrice,
                // shippingAddress: {
                //     factoryUnits: "Unit 1",
                //     country: "India",
                //     streetAddress: "Guddadahalli hatti",
                //     state: "karnataka",
                //     zipCode: 572117
                // }
            }

            console.log("en", enquiryData);

            const response = await api.createOrder(enquiryData)
            if (response.data) {
                toast.success(response?.data?.message || 'order created successfully')
                handleView(selectedIndex)
            }

        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'something went wrong')
        }
    }

    return (
        <Paper style={{ borderRadius: '12px', width: "60%" }}>
            <div style={{ padding: "20px", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                <h2>SUPPLIERS QUOTE</h2>
                <div onClick={() => setShowSupplier(false)} style={{ cursor: 'pointer' }}>

                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 15L10 10M10 10L5 5M10 10L15 5M10 10L5 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            {loadings ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div> :
                <TableContainer style={{ maxHeight: '320px', overflowY: 'auto', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                    <Table>
                        <TableHead style={{ background: "#CBCBCB" }}>
                            <TableRow>
                                <TableCell>Sl No</TableCell>
                                <TableCell>Suppliers</TableCell>
                                <TableCell>Unit price</TableCell>
                                <TableCell>MOQ</TableCell>
                                <TableCell>Date Code</TableCell>
                                {showEnquiryAction && <TableCell>Action</TableCell>}
                                {showOrderAction && <TableCell>Order</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.vendors?.length > 0 ?
                                <>
                                    {data?.vendors?.map((row, index) => (
                                        <TableRow key={row?._id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{row?.fullName}</TableCell>
                                            <TableCell>{row?.quotePrice || '-'}</TableCell>
                                            <TableCell>{row?.moq || '-'}</TableCell>
                                            <TableCell>{row?.datecode || '-'}</TableCell>
                                            {showEnquiryAction && <TableCell>
                                                {row?.enquiryStatus == "ORDERED" ? (
                                                    <div
                                                        variant="text"
                                                        style={{
                                                            color: "#7366FF",
                                                            fontWeight: row.status ? "bold" : "normal",
                                                        }}

                                                    >
                                                        ORDERED
                                                    </div>
                                                ) : row?.enquiryStatus == "SENT" ? (
                                                    <div
                                                        variant="text"
                                                        style={{
                                                            color: "#0EC649",
                                                            fontWeight: row.status ? "bold" : "normal",

                                                        }}

                                                    >
                                                        ENQUIRY SENT
                                                    </div>
                                                ) : (
                                                    <Button
                                                        variant="text"
                                                        style={{
                                                            color: row.status ? row.status : "#000000",
                                                            fontWeight: row.status ? "bold" : "normal",
                                                            textDecoration: 'underline',
                                                        }}
                                                        onClick={() => handleSendEnquiry(row)}
                                                    >
                                                        SEND ENQUIRY
                                                    </Button>
                                                )}
                                            </TableCell>}
                                            {showOrderAction && <TableCell>
                                                {!showEnquiryAction ?
                                                    // Order page: order directly from any supplier, no vendor quote needed
                                                    row?.enquiryStatus == "ORDERED" ?
                                                        <div style={{ color: "#7366FF", fontWeight: "bold" }}>ORDERED</div>
                                                        :
                                                        <IconButton onClick={() => handleCreateOrder(row)}>
                                                            <img src="/assets/ordericon.svg" alt="" />
                                                        </IconButton>
                                                    :
                                                    row?.status != 'QUOTED' ?
                                                    <IconButton disabled>
                                                        <Orderenq />
                                                    </IconButton>
                                                    :
                                                    <IconButton onClick={() => handleCreateOrder(row)}>
                                                        <img src="/assets/ordericon.svg" alt="" />
                                                    </IconButton>
                                                }
                                            </TableCell>}
                                        </TableRow>
                                    ))}
                                </>
                                :
                                <TableRow>
                                    <TableCell colSpan={5 + (showEnquiryAction ? 1 : 0) + (showOrderAction ? 1 : 0)} align="center" style={{ padding: '32px 16px', color: '#6B7280' }}>
                                        No Suppliers found for this product
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </Paper>
    );
};

export default SuppliersQuote;
